import { useSplitTreatment } from './useSplitTreatment';
import {
  SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL, SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL_COOKIE
} from 'constants/split';
import { useProduct } from '../../features/pdp';
import { IMAGE_CAROUSEL_TEST_SKUS } from 'constants/pdp';
import { useShouldDisplayPdpMobileTest } from './useShouldDisplayPdpMobileTest';

export const useShouldDisplayImageCarouselTest = (): boolean => {
  // We also want to display this image carousel if the PDP mobile test is enabled
  const shouldDisplayForPdpMobileTest = useShouldDisplayPdpMobileTest();

  const { product } = useProduct();
  const { treatmentStatus: imageCarouselTest } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL,
    SPLIT_IO_FEATURE_FLAG_IMAGE_CAROUSEL_COOKIE
  );

  const shouldDisplayForImageCarouselTest = imageCarouselTest && IMAGE_CAROUSEL_TEST_SKUS.includes(product.sku);

  return shouldDisplayForImageCarouselTest || shouldDisplayForPdpMobileTest;
};
